import React, { memo } from 'react'
import { FallbackLogoIcon } from './styles'

function FallbackLoading() {
  return <FallbackLogoIcon />
}

export default memo(FallbackLoading)
